import { axiosClient, axiosQAConfigPrivate } from '../../api';
import {
  API_QA_ADD_BLOCK,
  API_QA_AVAILABLE_QUESTION,
  API_QA_CREATE_QUESTION,
  API_QA_DELETE_EDIT_FILE,
  API_QA_DELETE_FILE,
  API_QA_DELETE_QUESTION,
  API_QA_EDIT_BLOCK,
  API_QA_FETCH_CATEGORIES,
  API_QA_FETCH_TABLE,
  API_QA_GET_QUESTION_EDIT,
  API_QA_GET_UPLOAD_FILE_LINK,
  API_QA_QUESTION_EDIT,
  API_QA_VISIBLE_QUESTION,
  API_QA_VISIBILITY_BLOCK,
  API_QA_UPDATE_SEQUENCE,
  API_QA_DELETE_BLOCK,
} from '../urls';

export const fetchCategories = async (sectionId) => {
  const params = {
    documentation_category_id: sectionId,
  };

  return axiosClient.get(API_QA_FETCH_CATEGORIES, await axiosQAConfigPrivate({}, { params }));
};

export const fetchTableData = async (queryParams) => {
  const params = {
    ...queryParams,
  };

  return axiosClient.get(API_QA_FETCH_TABLE, await axiosQAConfigPrivate({}, { params }));
};

export const createBlock = async (id, name) => {
  const data = {
    parent_id: id,
    name: name,
  };

  return axiosClient.post(API_QA_ADD_BLOCK, data, await axiosQAConfigPrivate());
};

export const deleteBlock = async (id) => {
  const params = {
    id,
  };

  return axiosClient.get(API_QA_DELETE_BLOCK, await axiosQAConfigPrivate({}, { params }));
};

export const updateBlock = async (idParent, id, name) => {
  const data = {
    parent_id: idParent,
    id: id,
    name: name,
  };

  return axiosClient.post(API_QA_EDIT_BLOCK, data, await axiosQAConfigPrivate());
};

export const updateTableSequence = async (items) => {
  const data = {
    items,
  };

  return axiosClient.post(API_QA_UPDATE_SEQUENCE, data, await axiosQAConfigPrivate());
};

export const getUploadAnswerFileLink = async (name, path) => {
  const params = {
    name: name,
    path: path,
  };

  return axiosClient.get(API_QA_GET_UPLOAD_FILE_LINK, await axiosQAConfigPrivate({}, { params }));
};

export const deleteAnswerFile = async (name, path) => {
  const params = {
    name: name,
    path: path,
  };

  return axiosClient.get(API_QA_DELETE_FILE, await axiosQAConfigPrivate({}, { params }));
};

export const deleteAnswerFileFromUpdate = async (id) => {
  const params = {
    id: id,
  };

  return axiosClient.get(API_QA_DELETE_EDIT_FILE, await axiosQAConfigPrivate({}, { params }));
};

export const createQuestion = async (data) =>
  axiosClient.post(API_QA_CREATE_QUESTION, data, await axiosQAConfigPrivate());

export const deleteQuestion = async (id) => {
  const params = {
    id: id,
  };

  return axiosClient.get(API_QA_DELETE_QUESTION, await axiosQAConfigPrivate({}, { params }));
};

export const changeVisibleQuestion = async (id, isActive) => {
  const params = {
    id: id,
    is_active: isActive,
  };

  return axiosClient.get(API_QA_VISIBLE_QUESTION, await axiosQAConfigPrivate({}, { params }));
};
export const changeAvailableQuestion = async (id, available) => {
  const params = {
    id: id,
    available: JSON.stringify(available),
  };
  return axiosClient.get(API_QA_AVAILABLE_QUESTION, await axiosQAConfigPrivate({}, { params }));
};

export const changeBlockVisibility = async (id, isActive) => {
  const params = {
    id: id,
    is_active: isActive,
  };
  return axiosClient.get(API_QA_VISIBILITY_BLOCK, await axiosQAConfigPrivate({}, { params }));
};

export const getCurrentQuestionData = async (id) => {
  const params = {
    id: id,
  };

  return axiosClient.get(API_QA_GET_QUESTION_EDIT, await axiosQAConfigPrivate({}, { params }));
};

export const updateQuestion = async (data) =>
  axiosClient.post(API_QA_QUESTION_EDIT, data, await axiosQAConfigPrivate());
